module.exports = __webpack_public_path__ + "static/media/Hotel-Generic.5634a37b.jpg";